export const concatActionReducers = (reducers, initialState: ?any) => (state: any = initialState, action) => {
  // eslint-disable-next-line no-prototype-builtins
  if (action.type && reducers.hasOwnProperty(action.type)) {
    // eslint-disable-line no-prototype-builtins
    return reducers[action.type](state, action)
  }
  return state
}
